import './locales'
import Root from './Root'
import { useHeaderControls } from './RootBase'

export default Root
export { default as AdminRoot } from './AdminRoot'
export { useHeaderControls }
export { OutageBannerWithoutData as OutageBanner } from './OutageBanner'
export { default as FrontierBaseProviders } from './FrontierBaseProviders'
